import React from 'react'

const Staffs = () => {
    return (
        <div>
            Staff
        </div>
    )
}

export default Staffs
